// extracted by mini-css-extract-plugin
module.exports = {"row":"Row_row__2By0w","row_title":"Row_row_title__VDd7w","row_value":"Row_row_value__1OOEz"};